<template>
    <div class="auth-wrapper auth-v2">
        <b-row class="auth-inner m-0">
            <!-- Brand logo-->
            <!-- <b-link class="brand-logo">
        <img src="@/assets/images/logo/derkoportallogo.png"/>
       
      </b-link> -->
            <!-- /Brand logo-->

            <!-- Left Text-->
            <b-col lg="7" class="d-none d-lg-flex align-items-center p-5">
                <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                    <b-img fluid :src="imgUrl" alt="Login V2" />
                </div>
            </b-col>
            <!-- /Left Text-->

            <!-- Login-->
            <b-col lg="5" class="d-flex align-items-center auth-bg px-2 p-lg-5">
                <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
                    <b-card-title title-tag="h2" class="font-weight-bold mb-1"> HNZ PORTAL'a hoş geldiniz! 👋 </b-card-title>
                    <b-card-text class="mb-2"> Sistemi kullanabilmek için lütfen giriş yapınız. </b-card-text>

                    <!-- Custom Tab Navigation -->
                    <div class="custom-tabs-container mb-4">
                        <div class="custom-tabs-wrapper">
                            <button type="button" class="custom-tab-btn" :class="{ active: activeTab === 'user' }" @click="activeTab = 'user'">
                                <feather-icon icon="UserIcon" size="18" class="mr-50" />
                                Kullanıcı Girişi
                            </button>
                            <button type="button" class="custom-tab-btn" :class="{ active: activeTab === 'company' }" @click="activeTab = 'company'">
                                <feather-icon icon="BuildingIcon" size="18" class="mr-50" />
                                Müşteri Girişi
                            </button>
                        </div>
                    </div>

                    <!-- User Login form -->
                    <validation-observer ref="loginValidation" v-show="activeTab === 'user'">
                        <b-form class="auth-login-form mt-2" @submit.prevent>
                            <!-- email -->
                            <b-form-group label="E-Posta" label-for="login-email">
                                <b-form-input id="login-email" v-model="userEmail" name="login-email" placeholder="john@example.com" />
                            </b-form-group>

                            <!-- forgot password -->
                            <b-form-group>
                                <div class="d-flex justify-content-between">
                                    <label for="login-password">Parola</label>
                                    <!-- <b-link :to="{name:'auth-forgot-password-v2'}">
                    <small>Şifrenizi mi unuttunuz?</small>
                  </b-link> -->
                                </div>
                                <validation-provider #default="{ errors }" name="Password" rules="required">
                                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                                        <b-form-input id="login-password" v-model="password" :state="errors.length > 0 ? false : null" class="form-control-merge" :type="passwordFieldType" name="login-password" placeholder="············" />
                                        <b-input-group-append is-text>
                                            <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!-- checkbox -->
                            <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

                            <!-- submit buttons -->
                            <b-button type="submit" variant="primary" class="d-flex align-items-center justify-content-center" block :disabled="loading" @click="validationForm">
                                <b-spinner small class="mr-50" v-if="loading"></b-spinner>
                                Giriş Yap
                            </b-button>
                        </b-form>
                    </validation-observer>

                    <!-- Company Login form -->
                    <validation-observer ref="companyLoginValidation" v-show="activeTab === 'company'">
                        <b-form class="auth-login-form mt-2" @submit.prevent>
                            <!-- Login Method Selection -->
                            <b-form-group class="mb-3">
                                <label class="form-label">Giriş Yöntemi</label>
                                <div class="login-method-tabs">
                                    <button type="button" class="method-tab" :class="{ active: companyLoginMethod === 'password' }" @click="selectLoginMethod('password')">
                                        <feather-icon icon="LockIcon" size="16" class="mr-25" />
                                        Parola ile Giriş
                                    </button>
                                    <button type="button" class="method-tab" :class="{ active: companyLoginMethod === 'otp' }" @click="selectLoginMethod('otp')">
                                        <feather-icon icon="SmartphoneIcon" size="16" class="mr-25" />
                                        OTP ile Giriş
                                    </button>
                                </div>
                            </b-form-group>

                            <!-- Password Login -->
                            <div v-if="companyLoginMethod === 'password'">
                                <!-- Contact input (email or phone) -->
                                <b-form-group>
                                    <label for="company-contact">E-Mail Adresi veya Telefon Numarası</label>
                                    <validation-provider #default="{ errors }" name="Contact" rules="required">
                                        <b-form-input id="company-contact" v-model="companyContact" :state="errors.length > 0 ? false : null" placeholder="ornek@email.com veya 5XX XXX XX XX" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>

                                <!-- Password input -->
                                <b-form-group>
                                    <label for="company-password">Parola</label>
                                    <validation-provider #default="{ errors }" name="CompanyPassword" rules="required">
                                        <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                                            <b-form-input id="company-password" v-model="companyPassword" :state="errors.length > 0 ? false : null" class="form-control-merge" :type="companyPasswordFieldType" placeholder="············" />
                                            <b-input-group-append is-text>
                                                <feather-icon class="cursor-pointer" :icon="companyPasswordToggleIcon" @click="toggleCompanyPasswordVisibility" />
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </div>

                            <!-- OTP Login -->
                            <div v-if="companyLoginMethod === 'otp'">
                                <!-- Contact input with OTP button -->
                                <b-form-group>
                                    <label for="otp-contact">E-Mail Adresi veya Telefon Numarası</label>
                                    <validation-provider #default="{ errors }" name="OtpContact" rules="required">
                                        <b-input-group>
                                            <b-form-input id="otp-contact" v-model="otpContact" :state="errors.length > 0 ? false : null" placeholder="ornek@email.com veya +90 5XX XXX XX XX" :disabled="otpSent && !otpExpired" />
                                            <b-input-group-append>
                                                <b-button variant="outline-primary" :disabled="otpLoading || (otpSent && !otpExpired) || !otpContact" @click="sendOtp">
                                                    <b-spinner small v-if="otpLoading" class="mr-50"></b-spinner>
                                                    <span v-if="!otpSent || otpExpired">OTP Gönder</span>
                                                    <span v-else-if="otpSent && !otpExpired">{{ formatTime(otpCountdown) }}</span>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>

                                <!-- OTP Code input -->
                                <b-form-group v-if="otpSent">
                                    <label for="otp-code">Doğrulama Kodu</label>
                                    <validation-provider #default="{ errors }" name="OtpCode" rules="required|min:6">
                                        <b-form-input id="otp-code" v-model="otpCode" :state="errors.length > 0 ? false : null" placeholder="6 haneli kodu giriniz" maxlength="6" @input="handleOtpInput" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                    <small class="text-muted mt-1"> {{ otpSentMethod === "email" ? "E-mail adresinize" : "Telefon numaranıza" }} gönderilen 6 haneli kodu giriniz </small>
                                </b-form-group>
                            </div>

                            <!-- Submit button -->
                            <b-button v-if="companyLoginMethod === 'password' || (companyLoginMethod === 'otp' && otpCode.length === 6)" type="submit" variant="primary" class="d-flex align-items-center justify-content-center" block :disabled="companyLoading" @click="validationCompanyForm">
                                <b-spinner small class="mr-50" v-if="companyLoading"></b-spinner>
                                {{ companyLoginMethod === "password" ? "Giriş Yap" : "OTP ile Giriş Yap" }}
                            </b-button>
                        </b-form>
                    </validation-observer>

                    <!-- Güvenlik ve Ödeme Göstergeleri -->
                    <div class="auth-trust-badges mt-4 text-center">
                        <div class="security-badges mb-2">
                            <img src="@/assets/images/footer/ssl-secure.png" alt="256-bit SSL Güvenlik" height="32" class="mx-0" />
                            <img src="@/assets/images/footer/3d-secure.png" alt="3D Secure" height="32" class="ml-1" />
                        </div>
                        <div class="payment-badges">
                            <img src="@/assets/images/footer/visa-logo.png" alt="Visa" height="28" class="mx-0" />
                            <img src="@/assets/images/footer/mastercard-logo.png" alt="Mastercard" height="28" class="mx-0 ml-1" />
                        </div>
                    </div>
                </b-col>
            </b-col>
            <!-- /Login-->
        </b-row>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner, BNav, BNavItem, BFormRadioGroup } from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { AuthApi } from "@/api/auth";
import Auth from "@/utilities/auth";
import { updateAuthHeader } from "@/config/axios.config";

export default {
    watch: {},
    components: {
        BRow,
        BCol,
        BLink,
        BFormGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroup,
        BFormCheckbox,
        BCardText,
        BCardTitle,
        BImg,
        BForm,
        BButton,
        BSpinner,
        BNav,
        BNavItem,
        BFormRadioGroup,
        VuexyLogo,
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            activeTab: "user", // default tab
            status: "",
            password: "",
            userEmail: "",
            // Company login fields
            companyContact: "", // email or phone for company login
            companyPassword: "",
            companyPasswordFieldType: "password",
            companyLoginMethod: "password", // 'password' or 'otp'
            // OTP fields
            otpContact: "", // email or phone number for OTP
            otpCode: "",
            otpSent: false,
            otpLoading: false,
            otpCountdown: 300, // 5 minutes in seconds
            otpTimer: null,
            otpExpired: false,
            otpSentMethod: "", // will be determined automatically from contact format
            sideImg: require("@/assets/images/logo/hnz-logo.png"),
            // validation rulesimport store from '@/store/index'
            required,
            email,
            loading: false,
            companyLoading: false,
        };
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
        },
        companyPasswordToggleIcon() {
            return this.companyPasswordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
        },
        imgUrl() {
            if (store.state.appConfig.layout.skin === "dark") {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sideImg = require("@/assets/images/logo/hnz-logo.png");
                return this.sideImg;
            }
            return this.sideImg;
        },
    },
    methods: {
        toggleCompanyPasswordVisibility() {
            this.companyPasswordFieldType = this.companyPasswordFieldType === "password" ? "text" : "password";
        },
        selectLoginMethod(method) {
            this.companyLoginMethod = method;
            // Reset form when switching methods
            this.resetCompanyForm();
        },
        resetCompanyForm() {
            this.companyContact = "";
            this.companyPassword = "";
            this.otpContact = "";
            this.otpCode = "";
            this.otpSent = false;
            this.otpExpired = false;
            this.clearOtpTimer();
        },
        isEmail(text) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(text);
        },
        detectContactMethod(contact) {
            return this.isEmail(contact) ? "email" : "sms";
        },
        formatTime(seconds) {
            const mins = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${mins}:${secs.toString().padStart(2, "0")}`;
        },
        startOtpTimer() {
            this.otpCountdown = 300; // 5 minutes
            this.otpExpired = false;
            this.otpTimer = setInterval(() => {
                this.otpCountdown--;
                if (this.otpCountdown <= 0) {
                    this.otpExpired = true;
                    this.clearOtpTimer();
                }
            }, 1000);
        },
        clearOtpTimer() {
            if (this.otpTimer) {
                clearInterval(this.otpTimer);
                this.otpTimer = null;
            }
        },
        handleOtpInput() {
            // Auto-submit when 6 digits are entered
            if (this.otpCode.length === 6 && /^\d{6}$/.test(this.otpCode)) {
                this.$nextTick(() => {
                    this.validationCompanyForm();
                });
            }
        },
        validationForm() {
            this.$refs.loginValidation.validate().then((success) => {
                if (success) {
                    this.loading = true;
                    AuthApi.Login({
                        Email: this.userEmail,
                        Password: this.password,
                    })
                        .then((res) => {
                            this.$result(res);
                            this.loading = false;
                            if (res.data.Success) {
                                Auth.isAuthenticated = true;
                                Auth.user = res.data.Data;
                                // this.$signalr.role.Configure()
                                // this.$signalr.notify.Configure()
                                // this.$signalr.userActive.Configure()
                                if (this.$route.query?.redirect) {
                                    this.$router.push(this.$route.query.redirect);
                                } else {
                                    this.$router.push({ name: "home" });
                                }
                            }
                        })
                        .catch((err) => {
                            this.loading = false;
                            this.$result(null, err);
                        });
                }
            });
        },
        validationCompanyForm() {
            this.$refs.companyLoginValidation.validate().then((success) => {
                if (success) {
                    this.companyLoading = true;

                    const handleSuccess = (res) => {
                        this.companyLoading = false;
                        this.$result(res);

                        if (res.data.Success) {
                            const responseData = res.data.Data;
                            const isCustomerLogin = !!responseData.CustomerCode;

                            Auth.setCustomerData(responseData);

                            this.handleCustomerRedirect(responseData, isCustomerLogin);
                        }
                    };

                    const handleError = (err) => {
                        this.companyLoading = false;
                        this.$result(null, err);
                    };

                    if (this.companyLoginMethod === "password") {
                        AuthApi.CustomerLogin({
                            loginIdentifier: this.companyContact,
                            password: this.companyPassword,
                        })
                            .then(handleSuccess)
                            .catch(handleError);
                    } else if (this.companyLoginMethod === "otp") {
                        this.clearOtpTimer();
                        AuthApi.VerifyCustomerOtp({
                            loginIdentifier: this.otpContact,
                            otpCode: this.otpCode,
                        })
                            .then(handleSuccess)
                            .catch(handleError);
                    }
                }
            });
        },
        sendOtp() {
            if (!this.otpContact) return;

            this.otpLoading = true;
            this.otpSentMethod = this.detectContactMethod(this.otpContact);

            AuthApi.SendCustomerOtp({
                loginIdentifier: this.otpContact,
            })
                .then((res) => {
                    this.$result(res);
                    this.otpLoading = false;
                    if (res.data.Success) {
                        this.otpSent = true;
                        this.startOtpTimer();
                        // this.$toast({
                        //   component: 'ToastificationContent',
                        //   props: {
                        //     title: 'OTP Gönderildi',
                        //     text: `Doğrulama kodu ${this.otpSentMethod === 'email' ? 'e-mail adresinize' : 'telefon numaranıza'} gönderildi.`,
                        //     variant: 'success',
                        //   },
                        // })
                    }
                })
                .catch((err) => {
                    this.otpLoading = false;
                    this.$result(null, err);
                });
        },
        redirectToHome() {
            try {
                if (this.$route.query?.redirect) {
                    this.$router.push(this.$route.query.redirect).catch((err) => {
                        console.log("Navigation handled:", err.message);
                    });
                } else {
                    this.$router.push({ name: "home" }).catch((err) => {
                        console.log("Navigation handled:", err.message);
                    });
                }
            } catch (error) {
                console.log("Router push error:", error);
            }
        },
        // redirectToCustomerDashboard(customerCode) {
        //   try {
        //     this.$router.push({
        //       name: "customer-account-detail",
        //       params: { code: customerCode }
        //     }).catch(err => {
        //       console.log('Navigation handled:', err.message)
        //     })
        //   } catch (error) {
        //     console.log('Router push error:', error)
        //   }
        // },
        handleCustomerRedirect(responseData, isCustomerLogin) {
            if (isCustomerLogin) {
                if (responseData.HasPassword) {
                    this.$router.push({ name: "customer-portal" }).catch((err) => {
                        console.log("Müşteri portalına yönlendirme yapıldı:", err.message);
                    });
                } else {
                    if (this.$route.path !== "/Auth/CustomerPasswordSetup") {
                        this.$router.push("/Auth/CustomerPasswordSetup").catch((err) => {
                            console.log("Şifre oluşturma sayfasına yönlendirildi:", err.message);
                        });
                    }
                }
            } else if (responseData.RedirectTo) {
                if (this.$route.path !== responseData.RedirectTo) {
                    this.$router.push(responseData.RedirectTo).catch((err) => {
                        console.log("Personel yönlendirmesi yapıldı:", err.message);
                    });
                }
            } else {
                this.$router.push({ name: "home" }).catch((err) => {
                    console.log("Varsayılan ana sayfaya yönlendirildi:", err.message);
                });
            }
        },
    },
    beforeDestroy() {
        this.clearOtpTimer();
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

// Custom Tab Styles
.custom-tabs-container {
    .custom-tabs-wrapper {
        display: flex;
        background: rgba(115, 103, 240, 0.08);
        border-radius: 0.75rem;
        padding: 0.375rem;
        gap: 0.25rem;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }

    .custom-tab-btn {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.75rem 1rem;
        border: none;
        border-radius: 0.5rem;
        background: transparent;
        color: #6e6b7b;
        font-weight: 500;
        font-size: 0.95rem;
        transition: all 0.25s ease;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
            color: #6782f0;
            background: rgba(115, 103, 240, 0.12);
            transform: translateY(-1px);
        }

        &.active {
            background: linear-gradient(135deg, #49829d 0%, #74b9cb 100%);
            color: white;
            box-shadow: 0 4px 12px rgba(115, 103, 240, 0.4);
            transform: translateY(-1px);

            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, transparent 100%);
                pointer-events: none;
            }
        }

        .feather {
            margin-right: 0.5rem;
        }
    }
}

// Login Method Tabs
.login-method-tabs {
    display: flex;
    background: rgba(115, 103, 240, 0.05);
    border-radius: 0.5rem;
    padding: 0.25rem;
    gap: 0.125rem;
    margin-top: 0.5rem;

    .method-tab {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.5rem 0.75rem;
        border: none;
        border-radius: 0.375rem;
        background: transparent;
        color: #6e6b7b;
        font-weight: 500;
        font-size: 0.875rem;
        transition: all 0.2s ease;
        cursor: pointer;

        &:hover {
            color: #7367f0;
            background: rgba(115, 103, 240, 0.1);
        }

        &.active {
            background: linear-gradient(135deg, #70aec1 0%, #52b0b8 100%);
            color: white;
            box-shadow: 0 2px 8px rgba(8, 161, 174, 0.3);
        }

        .feather {
            margin-right: 0.25rem;
        }
    }
}

// OTP Method Selection
.otp-method-selection {
    .custom-radio {
        .custom-control-label {
            font-weight: 500;
            color: #6e6b7b;

            &::before {
                border: 2px solid #d8d6de;
                transition: all 0.2s ease;
            }

            &::after {
                background-color: #08a1ae;
            }
        }

        .custom-control-input:checked ~ .custom-control-label::before {
            border-color: #08a1ae;
            background-color: #08a1ae;
        }
    }
}

// Enhanced form animations
.auth-login-form {
    animation: fadeInUp 0.4s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// Form input focus enhancements
.form-control:focus {
    border-color: #7367f0;
    box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.25);
}

// Button hover enhancements
.btn-primary {
    background: linear-gradient(135deg, #08a1ae 0%, #52b0b8 100%);
    border: none;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(115, 103, 240, 0.4);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }
}

.btn-outline-primary {
    border-color: #08a1ae;
    color: #08a1ae;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
        background: linear-gradient(135deg, #53a6ad 0%, #73aeb3 100%);
        border-color: #c2e1e4;
        transform: translateY(-1px);
        box-shadow: 0 4px 15px rgba(8, 161, 174, 0.3);
        color: #e6f0f1 !important;
    }
}

// OTP specific styles
.text-muted a {
    text-decoration: none;
    font-weight: 500;

    &:hover {
        text-decoration: underline;
    }
}

// OTP input group button styling
.input-group-append .btn-outline-primary {
    border-left: none;
    border-color: #d8d6de;

    &:hover:not(:disabled) {
        border-color: #08a1ae;
    }

    &:disabled {
        background-color: #f8f8f8;
        border-color: #d8d6de;
        color: #6e6b7b;
        opacity: 0.8;
    }
}

// Countdown timer styling
.input-group-append .btn-outline-primary span {
    font-family: monospace;
    font-weight: 600;
}

.auth-trust-badges {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    padding-top: 1.5rem;
    margin-top: 2rem;

    img {
        opacity: 0.85;
        transition: all 0.2s ease;
        filter: grayscale(20%);

        &:hover {
            opacity: 1;
            filter: grayscale(0%);
            transform: translateY(-2px);
        }
    }

    .security-badges {
        margin-bottom: 0.75rem;
    }
}
</style>
